<template>
  <div>
    <Head :title="`${form.name}`" />
    <button class="bg-teal-800 text-white rounded p-2 mr-2" @click="back()">
        <i class="fa fa-arrow-left"></i>
      </button>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/clients">Propietarios</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }} (${{form.balance}})
    </h1>

    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <div class="flex items-center px-8 py-4 bg-teal-800 text-white border-t border-gray-100">
        Actualizar Propietario
      </div>
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.street_id" :error="form.errors.street_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Calle">
                <option value="">Seleccionar</option>
                <option v-for="street in streets" :key="street.id" :value="street.id">
                    {{street.name}}
                </option>
            </select-input>
          <text-input v-model="form.companyName" :error="form.errors.companyName" class="pb-8 pr-6 w-full lg:w-1/2" label="Apartado" />
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre y Apellido" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Correo electrónico" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Teléfono" />
          <text-input v-model="form.identification" :error="form.errors.identification" class="pb-8 pr-6 w-full lg:w-1/2" label="Alias o Cédula" />
          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Dirección" />

        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Actualizar Propietarios</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    client: Object,
    organizations: Array,
    streets: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.client.name,
        email: this.client.email,
        phone: this.client.phone,
        identification: this.client.identification,
        companyName: this.client.companyName,
        address: this.client.address,
        balance: this.client.balance,
        typeClient: this.client.typeClient,
        street_id: this.client.street_id
      }),
    }
  },
  methods: {
    back() {
      window.history.back();
    },
    update() {
      this.form.put(`/clients/${this.client.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this client?')) {
        this.$inertia.delete(`/clients/${this.client.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this client?')) {
        this.$inertia.put(`/clients/${this.client.id}/restore`)
      }
    },
  },
}
</script>
